
import * as Cookies from 'js-cookie';
import { mapActions } from 'vuex';
import Loading from '../components/Loading.vue';
import SectionFire from '@/components/main/SectionFire.vue';
import SectionCard from '@/components/main/SectionCard.vue';
import SectionWebtoon from '@/components/main/SectionWebtoon.vue';
import SectionStory from '@/components/main/SectionStory.vue';
import SectionLive from '@/components/main/SectionLive.vue';
import SectionAd from '@/components/main/SectionAd.vue';
import SectionEvent from '@/components/main/SectionEvent.vue';
import SectionOpenChat from '@/components/main/SectionOpenChat.vue';
// import SectionActivity from '@/components/main/SectionActivity.vue';
import SectionQuiz from '@/components/main/SectionQuiz.vue';
import SectionWebtoons from '@/components/main/SectionWebtoons.vue';

import SectionRanking from '@/components/posts/SectionRanking.vue';
import KakaoHelper from '@/utils/KakaoHelper';

import common from '@/utils/common';
export default {
  mixins: [common],
  auth: false,
  components: {
    Loading,
    SectionFire,
    SectionCard,
    SectionWebtoon,
    SectionStory,
    SectionLive,
    SectionAd,
    SectionEvent,
    SectionOpenChat,
    // SectionActivity,
    SectionQuiz,
    SectionWebtoons,
    SectionRanking,
  },
  data() {
    return {
      loading: true,
      qrData: null,
      activateNoticePop: false,
      noticePopupContents: [],
      qrInfo: {},
      webtoonList: [],
      storyList: [],
      promotionList: [],
      fireList: [],
      rankings: [],
      liveTime: '2024-05-08T17:45:00',
      tempModalFlag: false,
      invitationInfo: {},
    };
  },
  head: {
    meta: [
      { name: 'google-adsense-account', content: 'ca-pub-9411006336667814' },
    ],
  },
  watch: {
    userLoaded(val) {
      if (val == true) {
        this.loading = false;
      }
    },
  },
  computed: {
    getHomeBanner1() {
      return this.$store.getters.getHomeBanner1;
    },
    getHomeBanner2() {
      return this.$store.getters.getHomeBanner2;
    },
    getHomeBanner3() {
      return this.$store.getters.getHomeBanner3;
    },
    // allLoaded() {
    //   //webtoonList, storyList, promotionList
    //   return (
    //     this.webtoonList.length > 0 &&
    //     this.storyList.length > 0 &&
    //     this.promotionList.length > 0
    //   );
    // },

    //
    userLoaded() {
      const authToken = Cookies.get('auth_token');
      const userInfo = this.$auth.user;
      if (userInfo?.id) {
        this.getQr();
      }

      this.getQrInfo();
      return !!(authToken && userInfo);
    },
  },
  methods: {
    handleWowflex() {
      //외부 링크 오픈
      window.open('https://wowflex.co.kr', '_blank');
    },
    handleLocalPostDemo() {
      this.$router.push('/party-post/v2');
    },
    ...mapActions([
      'FETCH_HOME_BANNER1',
      'FETCH_HOME_BANNER2',
      'FETCH_HOME_BANNER3',
    ]),

    async checkInvitation() {
      const response = await this.$axios.get('/api/auth/home/management-invitations');
      if (response.data) {
        this.invitationInfo = { ...response.data };
      }
    },

    async getQr() {
      const response = await this.$axios.get(
        `/api/qrcode/${this.$auth.user?.id}`
      );
      if (response.data) {
        this.qrData = response.data;
      }
    },
    async getQrInfo() {
      const token = Cookies.get('auth_token');
      console.log(token, 3232323232323);
      const response = await this.$axios.get('/api/auth/qrinfo', {
        headers: {},
      });
      this.qrInfo = { ...response.data };
    },
    async countClick(click_type, click_id) {
      // console.log(click_type, click_id, 333)
      const res = await this.$axios.post('/api/click-count', {
        click_type,
        click_id,
      });
    },
    async getWebtoon() {
      const response = await this.$axios.get('/api/webtoon');
      if (response.data) {
        this.webtoonList = response.data.post.sort((a, b) => {
          return b.id - a.id;
        });
        this.webtoonThumb = response.data.post[0].thumbnail;
        this.webtoonId = response.data.post[0].id;
      }
    },
    async getStoryList() {
      const response = await this.$axios.get('/api/promotion');
      if (response.data) {
        this.storyList = response.data.story.map((item) => {
          return {
            ...item,
            video_thumbnail: item.video_thumbnail
              ? item.video_thumbnail.replace(/0\.jpg/g, 'mqdefault.jpg')
              : '',
          };
        });
      }
    },
    async getPromotionList() {
      const response = await this.$axios.get('/api/promotion');
      if (response.data) {
        this.promotionList = response.data.promotion.map((item) => {
          return {
            ...item,
            video_thumbnail: item.video_thumbnail
              ? item.video_thumbnail.replace(/0\.jpg/g, 'mqdefault.jpg')
              : '',
          };
        });
      }
    },
    async getBanners() {
      let homeBanners;
      try {
        homeBanners = await this.$axios.get('/api/banners');
        if (homeBanners?.data) {
          this.homeBanners = [...homeBanners.data.data];
          this.FETCH_HOME_BANNER1(
            this.homeBanners.filter((banner) => {
              return banner.position === 'top';
            })
          );
          this.FETCH_HOME_BANNER2(
            this.homeBanners.filter((banner) => {
              return banner.position === 'middle';
            })
          );
          this.FETCH_HOME_BANNER3(
            this.homeBanners.filter((banner) => {
              return banner.position === 'bottom';
            })
          );
          this.loading = false;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getFireList() {
      const response = await this.$axios.get('api/fires');
      this.fireList = response.data.data
        .filter((item) => this.calculateRemainingTime(item.date_at) > 0)
        .sort(
          (a, b) =>
            this.calculateRemainingTime(a.date_at) -
            this.calculateRemainingTime(b.date_at)
        );
    },
    // async getRankings(rankingUrl, count) {
    //   const response = await this.$axios.get(`/api/${rankingUrl}/${count}`);
    //   this.rankings = [...response.data.districtRegisterCounts];
    // },
    async getRankings() {
      const response = await this.$axios.get(`/api/total-rankings`);
      this.rankings = [...response.data.data];
    },

    async getNoticeContents() {
      try {
        const { data } = await this.$axios.get('/api/popups');
        if (data.data.length) {
          this.noticePopupContents = data.data.filter((notice) => {
            return !Cookies.get(`popup`);
          });
          if (this.noticePopupContents.length === 0) {
            Cookies.set('allPopClosedToday', true, {
              expires: 1,
              secure: false,
            });
            return;
          }
          this.currentId = this.noticePopupContents[0].id;
          this.activateNoticePop = true;
        }
      } catch (error) { }
    },
    calculateRemainingTime(date) {
      const currentDate = new Date();
      const targetDate = new Date(date);
      const diffInSeconds = Math.floor((targetDate - currentDate) / 1000);
      return diffInSeconds > 0 ? diffInSeconds : 0;
    },
    handleDeepLink() {
      this.exceDeepLink();
      this.checkInstallApp();
    },
    exceDeepLink() {
      let url = 'jayuvillage://audio/';
      location.href = url;
    },

    checkInstallApp() {
      let check;
      let timer;

      const clearTimers = () => {
        clearInterval(check);
        clearTimeout(timer);
      };

      const isHideWeb = () => {
        if (document.webkitHidden || document.hidden) {
          clearTimers();
        }
      };

      check = setInterval(isHideWeb, 200);

      timer = setTimeout(() => {
        clearTimers();
        this.redirectStore();
      }, 500);
    },

    redirectStore() {
      const ua = navigator.userAgent.toLowerCase();
      if (confirm('자유마을 앱을 설치하시겠습니까?')) {
        if (ua.indexOf('android') > -1) {
          window.location.href =
            'https://play.google.com/store/apps/details?id=com.puritech.jayuvillage&hl=ko';
        } else if (ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1) {
          window.location.href =
            'https://apps.apple.com/kr/app/%EC%9E%90%EC%9C%A0%EB%A7%88%EC%9D%84/id6503334096';
        }
      }
    },
    openTempModal() {
      this.tempModalFlag = true;
    },
    handleBannerClikck1000() {
      const loggedIn = this.$auth.user;
      if (loggedIn) {
        //대체모달 활성화
        this.openTempModal();
      } else {
        this.$router.push('/register_landing');
      }
    },
    copyLink() {
      const url = 'https://jayuvillage.com/auth/register';
      navigator.clipboard
        .writeText(url)
        .then(() => {
          if (this.$store.state.isFlutter && window.alertChannel) {
            window.alertChannel.postMessage(
              '링크가 클립보드에 복사되었습니다.'
            );
          }
          alert('링크가 클립보드에 복사되었습니다.');
        })
        .catch((err) => {
          console.error('클립보드 복사 실패:', err);
          if (this.$store.state.isFlutter && window.alertChannel) {
            window.alertChannel.postMessage('클립보드 복사에 실패했습니다.');
          }
          alert('클립보드 복사에 실패했습니다.');
        });
    },
    shareRegister() {
      let kakaoHelper = new KakaoHelper(Kakao);
      if (this.$auth.user) {
        kakaoHelper.shareRegister();
        // kakaoHelper.initSharePost(this.item, this.$auth.user?.id);
      } else {
        this.$router.push('/auth/login');
      }
    },
  },
  async mounted() {
    await this.checkInvitation();
    // 쿠키 없으면 바로 loading false로 설정 (로그인 안 된 상태 판단)
    // const cookie = this.getCookie('auth_token');
    if (!Cookies.get('auth_token')) {
      this.loading = false;
    }

    // if(this.$auth.user) {
    //   this.qrSrc = require('@/assets/images/main/qr-mark.png');
    // }
    if (!Cookies.get('allPopClosedToday')) {
      await this.getNoticeContents();
    }
    console.log(this.$auth.user, 'index mounted 333333333');
    // if (this.userLoaded) {
    //   await this.getQr();
    //   await this.getQrInfo();
    // }
    await this.getRankings();
    // await this.getFireList();
    await this.getBanners();
    // await this.getWebtoon();
    // await this.getStoryList();
    // await this.getPromotionList();
  },
};
